/* eslint-disable no-unused-vars */
import { BarcodesLimits } from "@components/BarcodesLimits";
import { Barcodes } from "@components/Barcodes"
import {Benefits} from "@components/Benefits";
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import InsightsIcon from '@mui/icons-material/Insights';
import QrCode from "@mui/icons-material/QrCode";
import CasinoIcon from '@mui/icons-material/Casino';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { WinChance } from "@components/WinChance";
import { Categories } from "@components/Categories";
import { EditCategory } from "@components/Categories/Edit";
import { TestCode } from "@components/TestCode";
import { QrCode2, Analytics } from "@mui/icons-material";
import { Statistics } from "@components/Statistics";
import { Users } from "@components/Users";
import { Segments } from "@components/Segments";
import { EditSegment } from "@components/Segments/Edit";
import PeopleIcon from '@mui/icons-material/People';

export default [
    {path:'/test', component: TestCode, label: 'test', icon: SettingsInputAntennaIcon},
    {path:'/benefits', component: Benefits, label: 'Benefits', icon: InsightsIcon},
    {path:'/barcodes-limit', component: BarcodesLimits, label: 'Benefit Limits', icon: QrCode},
    {path:'/users', component: Users, label: 'Users', icon: PeopleAltIcon},
    {path:'/statistics', component: Statistics, label: 'Statistics', icon: Analytics},
    {path:'/barcodes', component: Barcodes, label: 'Barcodes', icon: QrCode2},
    {path:'/categories', component: Categories, label: 'Categories', icon: CasinoIcon},
    {path:'/segment', component: Segments, label: 'Segment', icon: PeopleIcon},
    {path:'/edit-segment/:id', component: EditSegment},
    {path:'/create-segment/', component: EditSegment},
    {path:'/edit-category/:id', component: EditCategory},
    {path:'/create-category', component: EditCategory},
];

